@let t = text();

<div class="hd-composite-create-form">
  <label class="hd-composite-create-form__field">
    <span class="hd-composite-create-form__label">{{ t.chart1Label }}</span>
    <ng-select
      class="hd-composite-create-form__select"
      appendTo="body"
      bindLabel="name"
      bindValue="id"
      [items]="charts()"
      [loading]="chartsLoading()"
      [clearable]="true"
      [placeholder]="t.chartPlaceholder"
      [ngModel]="chart1Id()"
      (ngModelChange)="chart1Id.set($event)"
    ></ng-select>
  </label>

  <label class="hd-composite-create-form__field">
    <span class="hd-composite-create-form__label">{{ t.chart2Label }}</span>
    <ng-select
      class="hd-composite-create-form__select"
      appendTo="body"
      bindLabel="name"
      bindValue="id"
      [items]="charts()"
      [loading]="chartsLoading()"
      [clearable]="true"
      [placeholder]="t.chartPlaceholder"
      [ngModel]="chart2Id()"
      (ngModelChange)="chart2Id.set($event)"
    ></ng-select>
  </label>

  @if (sameChartChosen()) {
    <div class="hd-composite-create-form__hint">{{ t.sameChart }}</div>
  }
  @if (error()) {
    <div class="hd-composite-create-form__error">{{ error() }}</div>
  }

  @if (calculateOnlyOffered()) {
    <!-- Default slaat de pagina de berekende composiet meteen op; dit vinkje geeft
         het oude gedrag (onopgeslagen tab met sterretje). -->
    <label class="hd-composite-create-form__calc-only">
      <input
        type="checkbox"
        class="hd-composite-create-form__calc-only-check"
        [checked]="calculateOnly()"
        (change)="calculateOnly.set($any($event.target).checked)"
      />
      {{ t.calculateOnlyLabel }}
    </label>
  }

  <div class="hd-composite-create-form__actions">
    <button eBtn type="button" color="highlight" (click)="cancelled.emit()">
      {{ t.cancel }}
    </button>
    <button eBtn type="button" color="primary-75" icon="check" [disabled]="!canSubmit" (click)="submit()">
      {{ loading() ? t.calculating : t.submit }}
    </button>
  </div>
</div>
